export default __webpack_public_path__ + "static/media/slider-1.abbfdb53.png";